export const LAST_FLOOR_STORAGE_KEY = 'lastFloorId';
